import f from "../../../funcs";
import $ from "jquery";
import Marionette from "marionette";
import ScrollBar from "../../../classes/scroll/ScrollBar";
import "css!apps/Notification/view/css/NotifyView";
import template from "apps/Notification/view/template/NotifyView.html";


let NotifyView = Marionette.ItemView.extend("NotifyView", {
    className: "Notification no-select theme-background-color theme-border-color-dark1",
    template,
    events: {
        mousedown: "onMousedown",
        click: "onClick",
        "click .Notification--close": "onClickClose"
    },

    onClickClose(e) {
        e.preventDefault();
        this.trigger("close");
    },

    ui: {
        $close: ".Notification--close",
        $img: ".Notification--img",
        $viewport: ".Notification--text",
        $overview: ".Notification--textOverview"
    },

    onRender() {
        this.$el.attr("data-color", this.model.get("color"));
        let icon = this.model.get("icon");
        if ( icon ) {
            this.$el.addClass("Notification-icon-" + icon);
        }

        let img = this.model.get("img");

        if ( this.model.get("user") ) {
            this.$el.addClass("Notification-with-user");

            img = this.model.get("user").img;
        }

        if ( img ) {
            this.$el.addClass("Notification-with-img");

            let image = new Image();
            image.onload = image.onerror = () => {
                if ( this.el && this.ui.$img && this.ui.$img.removeClass ) {
                    this.ui.$img.removeClass("Notification--img-loading");
                }
            };

            image.onerror = () => {
                let user = this.model.get("user");
                if ( f.isObject(user) ) {
                    delete user.img;
                    this.render();
                }
            };

            image.src = img;
        }

        this.scroll = new ScrollBar({
            $box: this.ui.$viewport
        });
        this.scroll.on("moveTop", this.onScroll.bind(this));

        $(window).on("mouseup", this.onMouseup.bind(this));
    },

    onClick(e) {
        if ( this.ui.$close.hasChild(e.target) || e.target == this.ui.$close.get(0) ) {
            return;
        }

        if ( this.scroll._scrollEnded ) {
            return;
        }

        e.preventDefault();

        if ( e.target.tagName.toLowerCase() == "a" ) {
            system.runLink(e.target.href);
            return;
        }

        this.trigger("click", e);
    },

    onScroll(position) {
        this.ui.$overview.css("top", -position + "px");
    },

    onMousedown(e) {
        let $target = $(e.target);

        if ( $target.is(".ScrollBar *") ) {
            this.$el.addClass("scrolltrack-mousedown");
        }
    },

    onMouseup() {
        this.$el.removeClass("scrolltrack-mousedown");
    }
});

export default NotifyView;
